import Flash from "../../images/newDesign/flash.svg";

export const storeMock = [
    {
        icon: Flash,
        title: 'nice handyman',
        paragraphs: [
            'שיפוצים ואחזקה ברמה הגבוהה ביותר – כל הפתרונות לבית תחת קורת גג אחת!',
            'אנו מתמחים בשיפוצים, צביעה מקצועית, תיקונים כלליים, איטום נגד גשם, טיפול בעובש, אינסטלציה ועוד. השירות שלנו מותאם אישית לצרכים שלך, תוך דגש על איכות, אמינות ומקצועיות.',
            'בין אם זה שדרוג קטן או פרויקט שיפוץ רחב – אנחנו כאן כדי להפוך את הבית שלך למקום שתמיד חלמת עליו!',
            '✨ שירות אמין, מקצועי ומהיר – צרו קשר עוד היום! ✨',
        ],
        contactPhone: '0523685962',
        id: 'niceHandyMan',
    },
    {
        icon: Flash,
        title: 'מנורה ERN שכירות',
        paragraphs: [
            'אל תקחו סיכונים על הנכס שלכם! הצטרפו לשירות התחייבות לפרעון דמי השכירות.',
            'בדיקת דיירים חינמית',
            'מימון מלוא דמי השכירות שנה מראש',
            'שקט נפשי ויציבות כלכלית',
        ],
        contactPhone: '050-0000000',
        id: 'MenoraRent',
    },
    {
        icon: Flash,
        title: 'אינסטלטור - עידן בן הרוש',
        paragraphs: [
            'פרטים - צילום קווי ביוב, איתור נזילות, פתיחת סתימות , קרסום שורשים, החלפת כלים סניטריים',
            'תיקון ניאגרות, סמויות, הגברת לחץ מים, תיקון דוד שמש',
            'אזורים: עתלית , טירת כרמל , חיפה , קריות , עכו , נהריה',
        ],
        contactPhone: '053-5535505',
        id: 'PlumberIdan',
    },
    {
        icon: Flash,
        title: 'אינסטלטור - אלירן שושן',
        paragraphs: [
            'אזורי פעילות: חיפה והסביבה, קריות, ישובי חוף כרמל עד עתלית כולל, טירת כרמל, נשר',
            'אינסטלטור אינסטלציה סנטרית תיקון נזילות פתירת בעיות אינסטלצייה, שירותי',
            'אינסטלצייה 24/7, תיקון והתקנת כל סוגי הברזים, פתיחת סתימות ביוב, הוצאת שורשים',
            'וקטילתם, דיפון ותיקון שוחות ביוב, העברת נקודות מים חדשות, תיקון והתקנת דודי שמש',
            'וחשמל, תיקון והתקנת טוחני אשפה, תיקון והתקנת ברי מים, תיקון והתקנת אביזרי סניטריה',
            'אינסטלצייה, תיקון נזילות וביצוע מעקפי צנרת, תיקון והתקנת ניאגרות ואסלות, תיקון אסלות',
            'סמויות ומנגנונים, התקנה מדיחים ומכונות כביסה'
        ],
        contactPhone: '0509663302',
        id: 'PlumberEliran',
    },
    {
        icon: Flash,
        title: 'רפאל עדו טכנאי מזגנים',
        paragraphs: [
            'תיקון מזגנים',
            'לא מבצע התקנות',
            'איזור השירות:',
            'תל אביב',
            'רמת גן',
            'גבעתיים',
            'סמויות ומנגנונים, התקנה מדיחים ומכונות כביסה'
        ],
        contactPhone: '0503019109',
        id: 'RaphaelIdoAirConditioner',
    },
    {
        icon: Flash,
        title: 'בריק פתרונות הדברה',
        paragraphs: [
            'שירותי הדברת תיקנים,נמלים טרמיטים, פשפש מיטה, מכרסמים',
        ],
        contactPhone: '050-345-2551',
        id: 'BrickPestControl',
    },

]
